import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FormText as FormTextElem } from './Contact.styles';

const MAX_CHAR = 500;

const Textarea = React.forwardRef(({ name, required, label }, ref) => {
  const [count, getCount] = useState(500);

  const keyhandler = (e) => {
    getCount(500 - e.target.value.length);
  };

  return (
    <>
      <FormTextElem
        id={name}
        type="text"
        name={name}
        maxLength={MAX_CHAR}
        className="border-primary rounded-none border-b-2 block w-full focus:outline-none"
        aria-label={label}
        aria-required="true"
        placeholder=" "
        onKeyUp={(e) => keyhandler(e)}
        ref={ref}
      />
      <label className="block absolute top-0 left-0 transition-all duration-150 text-basic-500" htmlFor={name}>
        {label} {required && '*'}
      </label>
      <div className="text-tiny">
        Nog <span className="font-bold">{count}</span> tekens resterend
      </div>
    </>
  );
});

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

Textarea.defaultProps = {
  required: false,
};

export default Textarea;
